import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/models/notification.message';
import { ChangePasswordVm } from 'src/app/models/requests/ChangePasswordVm';

import { NotificationService } from 'src/app/services/notification.service';
import { SharedService } from 'src/app/services/shared.service';

import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-accountConfirmation',
  templateUrl: './accountConfirmation.component.html',
  styleUrls: ['./accountConfirmation.component.css']
})
export class AccountConfirmationComponent implements OnInit {
  visible:boolean = true;
  showvisible:boolean = true;
  changetype:boolean = true;
  newchangetype:boolean = true;
  showConfirmVisible: boolean = true;
  newConfirmChangeType: boolean = true;
  today = new Date();
  currentPassword: string = '';
  password: string = '';
  confirmPassword: string = '';

  constructor(private userService: UserService, private router: Router, private notification: NotificationService, private sharedService: SharedService) { }


  ngOnInit(): void {

  }

  
  viewcurrentpassword(){
    this.visible = !this.visible;
    this.changetype = !this.changetype;
  }

  
  showpassword(){
    this.showvisible = !this.showvisible;
    this.newchangetype = !this.newchangetype;
  }

  
  showconfirmpassword(){
    this.showConfirmVisible = !this.showConfirmVisible;
    this.newConfirmChangeType = !this.newConfirmChangeType;
  }
  onSubmit(): void {
    if (this.confirmPassword != this.password) {

      this.notification.sendMessage({
        message: 'New Password and confirm password do not match',
        type: NotificationType.error
      });
      return;
    }

    this.changePassword();

  }

  changePassword() {
    const changepwdModel: ChangePasswordVm = {} as ChangePasswordVm;
    changepwdModel.newPassword = this.password;
    changepwdModel.currentPassword = this.currentPassword;

    this.userService.chanegPassword(changepwdModel).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          window.localStorage.clear();
          this.router.navigate(['signin']);

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

}
